import classNames from "classnames";

function ResId({ className = "", id }: { className?: string; id?: string }): JSX.Element | null {
  if (!id) return null;
  return <div className={classNames(className)}>{id}</div>;
}

export default ResId;
